import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "svg-icon"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M4.5 3v9c-3 0-4-1-4.5-2l4.5-7ZM9 3c0 1.5 1.5 3.5 3 4 1.5-.5 3-2.5 3-4h3v17s-1.5 1-6 1-6-1-6-1V3h3ZM19.5 12V3l4.5 7c-.5 1-1.5 2-4.5 2Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }